import * as Yup from 'yup';
import { getDefaultItemId } from 'src/components/formik-utils';

export const initialValues = (formik, item) => {
  if(!formik) return;
  const myId = getDefaultItemId(item);

  if(0 < myId){
    formik.setFieldValue('id', myId);
    formik.setFieldValue('ticketId', item.ticket?.id || 0);
  }else{
    formik.setFieldValue('plateField', null);
  }
};

export const validationSchema = (item) => {
  const isCreate = !item?.id;
  let schema = Yup.object();
  schema = schema.shape({
      plateField: Yup.object()
        .nullable()
        .when([], {
          is: () => isCreate,
          then: (schema) => schema.required('Vui lòng chọn biển số'),
          otherwise: (schema) => schema.nullable(),
        }),
    });
  return schema;
};

export const handleSubmitted = async (values, item, apiUpdate, apiRemove, apiTicket) => {  
  const isUpdate = values?.id;
  if (isUpdate) {
    if(values.isVerified){
      await apiRemove(values)
    }else{
      if(values.ticketId > 0){
        await apiTicket({
          moduleType: 0,
          ticketId: values.ticketId,
          status: 1
        });
      }
      
      await apiUpdate(values);
    }
  }
};
